{
	"language": {
		"select": "Select language",
		"sectionTitle": "Language",
		"changeSuccess": "Language changed successfully"
	},
	"assistant": {
		"composer": {
			"placeholder": "Ask {{assistantName}}",
			"disclaimer": "{{assistantName}} can make mistakes. Check important info."
		},
		"greeting": {
			"initialMessage": "👋 Hey there, I'm the **{{assistantName}}** learning assistant, and I'm here to help you better prepare for **{{context}}!** Let's specifically dig into the item you answered about **{{topic}}.**",
			"starter": "Hey there, I'm **{{assistantName}}**. How can I help?"
		},
		"chips": {
			"askYourOwn": "Ask your own question",
			"askFollowUp": "Ask a follow-up"
		},
		"emptyState": {
			"title": "{{assistantName}} is your AI-Powered Learning Assistant",
			"contextSubtitle": "Ask anything related to {{context}}",
			"activateSubtitle": "{{assistantName}} will activate after you answer the question"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Quick study",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Set exam date",
					"examDateWithValue": "Exam date: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Could be better",
				"itsAwesome": "It's awesome"
			},
			"title": "You're on a roll!",
			"body": "We're thrilled to see your dedication to studying! How's your experience with the app so far? Would you mind sharing your thoughts with a review?",
			"cta": "May be later"
		},
		"actions": {
			"studyWeak": "Focus on weak areas",
			"viewProgress": "See your progress",
			"seeRank": "Check your rank",
			"seeRankings": "View leaderboard",
			"unlock": "Unlock premium content",
			"unlockTooltip": "Gain access to exclusive features and advanced study materials by unlocking premium content",
			"startCustomSession": "Create a custom session",
			"startCustomSessionTooltip": "Start a custom study session to focus on specific areas of your study",
			"takeDiagnostic": "Take diagnostic",
			"takeDiagnosticTooltip": "Take a diagnostic to assess your current level and tailor your study plan accordingly",
			"viewDiagnostic": "View diagnostic results",
			"viewDiagnosticTooltip": "View your diagnostic results to see your strengths and areas for improvement",
			"viewPodcasts": "Listen to podcasts",
			"viewPodcastsTooltip": "Access educational podcasts to enhance your learning experience",
			"upgradeToPremium": "Go premium",
			"upgradeToPremiumTooltip": "Upgrade to premium to access all content and features",
			"extendAccess": "Extend access",
			"extendAccessTooltip": "Extend your access to premium content and features",
			"setExamDate": "Set exam date",
			"setExamDateTooltip": "Set your exam date to track your progress and prepare for your exam"
		},
		"exam": {
			"daysAgo_one": "{{count}} day ago",
			"daysAgo_other": "{{count}} days ago",
			"untilExam_one": "{{count}} day until exam",
			"untilExam_other": "{{count}} days until exam",
			"isToday": "Exam is today!"
		},
		"stats": {
			"mastery": "Mastery",
			"completed_one": "Item answered",
			"completed_other": "Items answered",
			"completedValue": "{{count}}",
			"xpEarned": "XP earned",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Accuracy",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "Your estimated {{skill, lowercase}} proficiency is {{level, lowercase}}",
			"itemsAnsweredTooltip": "Total number of items you have answered so far",
			"responsesAnsweredTooltip": "Total number of answers you have submitted so far",
			"examDateTooltip": "Your exam is on {{date}}",
			"skillCta": {
				"diagnostic": "Diagnostic",
				"practice": "Practice"
			}
		},
		"menu": {
			"settings": "Settings",
			"profile": "Profile"
		},
		"diagnostics": {
			"title": "Diagnostics",
			"free": "Free",
			"duration": "{{count}} {{item}} • {{minutes}} mins",
			"completed": "{{count}} {{item}} completed",
			"start": "Start",
			"viewReport": "View report",
			"resume": "Resume"
		},
		"practiceTests": {
			"title": "Practice Tests",
			"sectionalTestsTitle": "Sectional Tests",
			"diagnosticAssessmentsTitle": "Diagnostic Assessments",
			"premiumChipTooltip": "Full-length, premium practice tests for the {{examName}} exam",
			"freeChipTooltip": "{{label}} for the {{examName}} exam",
			"freeChipTooltipDefault": "Free diagnostic assessments for the {{examName}} exam",
			"completedDescription_one": "{{count}} item • {{date}}",
			"completedDescription_other": "{{count}} items • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} item • {{timeRemaining}} remaining",
			"activeDescription_other": "{{attempted}}/{{count}} items • {{timeRemaining}} remaining",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} item • {{timeRemaining}} remaining • Started on: {{startedOn}} • Ends on: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} items • {{timeRemaining}} remaining • Started on: {{startedOn}} • Ends on: {{endsOn}}",
			"notStartedDescription_one": "{{count}} item • {{duration}}",
			"notStartedDescription_other": "{{count}} items • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} item • {{duration}} • Ends on: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} items • {{duration}} • Ends on: {{endsOn}}",
			"viewResultsCta": "View results",
			"startCta": "Start",
			"chips": {
				"items_one": "{{count}} item",
				"items_other": "{{count}} items",
				"progress_one": "{{attempted}}/{{count}} item",
				"progress_other": "{{attempted}}/{{count}} items",
				"timeRemaining": "{{time}} remaining",
				"startedOn": "Started on {{date}}",
				"endsOn": "Ends on {{date}}",
				"timeLeft": "{{time}} left"
			},
			"status": {
				"notStarted": {
					"label": "Not started",
					"section": "Full-Length Practice Tests"
				},
				"inProgress": {
					"label": "In progress",
					"section": "In progress"
				},
				"completed": {
					"label": "Completed",
					"section": "Completed"
				},
				"legacyReports": {
					"label": "Legacy reports",
					"section": "Legacy reports"
				},
				"migratedReports": {
					"label": "Migrated reports",
					"section": "Migrated reports"
				}
			}
		},
		"skills": {
			"title": "Skills",
			"unlockSubtitle": "Unlock premium to practice",
			"startCta": "Practice",
			"freeItemsIncludedChip": "Free items included",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} of {{count, number}} free item answered",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} of {{count, number}} free items answered",
			"progressCards": {
				"questionTypesTitle": "Performance by question type",
				"questionTypesSubtitle": "How you score across {{skill}} question types",
				"proficiencyTitle": "Performance by proficiency",
				"proficiencySubtitle": "Your progress across {{skill}} levels",
				"questionTypeCardSubtitle": "Progress by proficiency level",
				"bySkillTitle": "Performance by skill",
				"bySkillSubtitle": "Overall progress across skills",
				"needsImprovementTitle": "Needs improvement",
				"needsImprovementSubtitle": "Topics to focus on next",
				"skillPerformanceTitle": "{{skill}} performance",
				"skillPerformanceSubtitle": "Progress by question type and proficiency",
				"skillLevelSubtitle": "Your progress across this skill level",
				"skillsPerformanceTitle": "Skills Performance",
				"performanceByItemDifficulty": "Performance by item proficiency",
				"performanceByItemDifficultyCaption_one": "Shows your accuracy by proficiency level, based on {{count}} item answered",
				"performanceByItemDifficultyCaption_other": "Shows your accuracy by proficiency level, based on {{count}} items answered",
				"questionTypePartSubtitle": "{{skill}} · Part {{part}}",
				"activityGoalTitle": "Activity & Goal Progress",
				"recentActivityTitle": "Recent Activity",
				"goalProgressTitle": "Goal Progress",
				"goalProgressSubtitle": "Overall score · Last 7 weeks",
				"goalProgressInsight": "You're improving steadily. You are 14 points below your target and may reach your goal in about 3 weeks.",
				"goalProgressActualLabel": "Your score",
				"goalProgressTargetLabel": "Target",
				"goalProgressTimeAxisLabel": "Time",
				"goalProgressScoreAxisLabel": "Overall Progress",
				"statusTitle": "Your Status",
				"diagnosticsTitle": "Diagnostics",
				"diagnosticsReviewCta": "Review",
				"strengthsFocusTitle": "Strengths & Focus Areas",
				"strengthsFocusSubtitle": "Your strongest areas and the question types that need more practice",
				"strengthsLabel": "Strengths",
				"focusAreasLabel": "Focus Areas",
				"recommendedNextStepLabel": "Recommended Next Step",
				"recommendedNextStepCta": "Start",
				"practiceTestsViewMore": "View all {{count}} tests"
			},
			"proficiencySection": "Practice by proficiency level"
		},
		"recommendedTasks": {
			"sectionTitle": "Recommended for you",
			"startSessionAction": "Practice",
			"resumeAction": "Resume",
			"reviewResultsAction": "Review results",
			"startTestAction": "Start test",
			"activeTestBody": "Complete your in-progress assessment",
			"completedTestBody": "Review your results and personalized insights",
			"diagnosticBody": "Take {{label}} to get a baseline and become familiar with the exam format",
			"diagnosticDefaultLabel": "free diagnostic",
			"practiceTestBody": "Assess your readiness with a timed mock exam",
			"sectionalTestBody": "Take a focused test to practice your {{skills}} skills",
			"weakSkillTitle": "Build your {{skill}} skills",
			"weakSkillBody": "{{questionType}} practice, focused on where you need to improve",
			"strongSkillTitle": "Keep your {{skill}} skills sharp",
			"strongSkillBody": "Maintain your strengths in {{questionType}} with additional practice",
			"mixedSkillTitle": "Improve your {{skill}} skills",
			"mixedSkillBody": "Practice question types like {{questionTypes}}, with a focus on where you need to improve",
			"higherDifficultySkillTitle": "Level up to {{proficiency}}",
			"higherDifficultySkillBody": "Now that you're doing well with {{questionType}}, it's time to increase the difficulty",
			"itemsChip_one": "{{count}} item",
			"itemsChip_other": "{{count}} items",
			"timeRemainingChip": "{{minutes}} min left",
			"timeRemainingChipCompact": "{{minutes}} min"
		},
		"itemTypes": {
			"answeredLabel_one": "Item answered",
			"answeredLabel_other": "Items answered",
			"answeredAll": "All",
			"answeredPartial": "{{answered}} of {{total}}",
			"cardSubtitleComplete": "All items answered",
			"cardSubtitlePartial": "{{attempted}} of {{total}} items answered",
			"cardSubtitleResponses_one": "{{count}} response",
			"cardSubtitleResponses_other": "{{count}} responses",
			"responsesLabel_one": "Response",
			"responsesLabel_other": "Responses",
			"detail": {
				"skillLabel": "Skill",
				"estimatedLevelLabel": "Estimated level"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} response",
			"responseCount_other": "{{count, number}} responses"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} practice item included for free",
			"freeContentBannerTitle_other": "{{count, number}} practice items included for free",
			"freeContentBannerBody": "Practice selected {{skills}} items anytime. Upgrade to unlock the complete Study Pack.",
			"freeContentBannerCta": "Start free practice",
			"freeSampleBanner": {
				"body_one": "Practice selected items from {{categories}} anytime. Upgrade to unlock {{count, number}} more item.",
				"body_other": "Practice selected items from {{categories}} anytime. Upgrade to unlock {{count, number}} more items.",
				"moreTags": "{{count, number}} more {{label}}",
				"cta": "Upgrade"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "See how you stack up against others"
		},
		"home": {
			"title": "Home"
		},
		"podcasts": {
			"description": "Listen to expert-led orthopedic podcasts."
		},
		"more": {
			"title": "More Settings"
		}
	},
	"emptyState": {
		"progress": {
			"title": "No study progress",
			"subtitle": "As you study your progress will show up here",
			"cta": "Study now"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Error",
			"body": "Session creation failed, please try again"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Advanced",
			"highIntermediate": "Intermediate",
			"intermediate": "Intermediate",
			"basic": "Basic",
			"none": "Not answered",
			"high": "Mastered",
			"medium": "Almost there",
			"low": "Needs work"
		}
	},
	"leaderboard": {
		"you": "This is you",
		"periods": {
			"all_time": "All time",
			"month": "This month",
			"week": "This week"
		},
		"scope": {
			"global": "Global",
			"friends": "Friends"
		},
		"friends": {
			"soon": "SOON",
			"comingSoonTitle": "Friends leaderboard",
			"comingSoonBadge": "Coming soon",
			"comingSoonDescription": "Track your progress against friends and see who is at the top of the class."
		},
		"error": {
			"title": "Connection error",
			"description": "Unable to load leaderboard. Check your connection and try again.",
			"tryAgain": "Try again"
		},
		"empty": {
			"title": "No leaders yet",
			"description": "Rankings update as more people study. Be the first to earn XP and claim the top spot!",
			"startLearning": "Study now"
		},
		"topPerformers": "Top performers",
		"yourPosition": "Your position",
		"rankings": "Rankings",
		"rankingsRange": "Rankings • #{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Earn XP to join rankings!",
			"description": "Start a study session to earn your first points and join the leaderboard.",
			"cta": "Start your first session"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "You",
		"podium": {
			"first": "1st",
			"second": "2nd",
			"third": "3rd"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>to pass #{{rank}}</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>from the podium</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Lessons",
			"statusFilter": {
				"all": "All",
				"inProgress": "In Progress",
				"notStarted": "Not Started",
				"completed": "Completed"
			},
			"card": {
				"openCta": "Open",
				"resumeCta": "Resume",
				"viewResultsCta": "View results",
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			},
			"viewToggle": {
				"list": "List view",
				"grid": "Grid view"
			},
			"empty": {
				"filteredTitle": "No lessons match this filter",
				"filteredSubtitle": "Try a different status filter",
				"filteredCta": "Show all",
				"noneTitle": "No lessons found",
				"noneSubtitle": "Try removing filters or starting a new search",
				"noneCta": "Reset all"
			}
		},
		"home": {
			"hero": {
				"greeting": "Welcome, {{name}}!",
				"greetingNoName": "Welcome!"
			},
			"stats": {
				"modulesDone": "Modules done",
				"dayStreak": "Day Streak",
				"minutesToday": "Min Today"
			},
			"suggested": {
				"title": "Suggested for you",
				"openModuleCta": "Open module",
				"status": {
					"ready": "Ready",
					"next": "Next"
				}
			},
			"all": {
				"title": "All lessons"
			},
			"emptyState": {
				"title": "No lessons yet",
				"subtitle": "Check back soon for new lessons."
			},
			"card": {
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			}
		},
		"overview": {
			"header": {
				"title": "Overview"
			},
			"startCta": "Start learning",
			"objectives": {
				"title": "Learning objectives"
			}
		},
		"detail": {
			"takeQuizCta": "Take the quiz",
			"progress": {
				"label": "Module progress"
			},
			"activities": {
				"title": "Activities",
				"completedCount": "{{completed}} out of {{total}} completed"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "Progress insights"
			},
			"milestones": {
				"title": "Module milestones",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "Read"
			},
			"readTime": "{{count}} min read",
			"sectionBadge": {
				"label": "Section {{number}} of {{total}}"
			},
			"upNext": {
				"title": "Up next"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "Custom study session",
		"diagnostic": "Diagnostic",
		"skill": "Skills",
		"Proficiency": "Proficiency",
		"Question Type": "Question types",
		"mastery": "Mastery",
		"sessionLength": "Session length",
		"itemsChip_one": "{{count}} item",
		"itemsChip_other": "{{count}} items",
		"durationEstimate": "{{minutes}} min",
		"durationRange": "{{min}}–{{max}} min",
		"noItemsTooltip": "No items match the current filters",
		"setCount": "{{count}} {{type}}",
		"dismiss": "Ok",
		"status": {
			"notAnswered": "Not answered",
			"needsWork": "Needs work"
		},
		"itemCount": "You will complete {{count}} items across {{topics}}",
		"start": "Start session",
		"configuringSession": "Configuring session",
		"fetchingContent": "Fetching content",
		"preparingMaterials": "Preparing materials",
		"almostThere": "Almost there",
		"startingSession": "Starting session",
		"playIcon": "play-outline",
		"infoText": "You'll complete **{{numItems}}** {{itemCount}}. This will take about **{{timeString}}**.",
		"customSummary": {
			"message": "Study $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) from {{topics}}.",
			"messageWithMastery": "Study $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) from {{topics}}, focusing on the {{masteryLevels}} $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}).",
			"messageAllMasteryLevels": "Study $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) from {{topics}} across all mastery levels.",
			"itemCount_one": "{{count}} item",
			"itemCount_other": "{{count}} items",
			"masteryLevelCount_one": "mastery level",
			"masteryLevelCount_other": "mastery levels",
			"allTopics": "all {{count}} topics",
			"more": "{{count}} more",
			"quotedMasteryLevel": "“{{masteryLevel}}”"
		},
		"quickStudy": {
			"title": "Quick Study",
			"recommended": "Recommended",
			"custom": "Custom",
			"selectHelper": "Tap a session to select it, then start when you're ready.",
			"emptyRecommended": "No recommended sessions are available right now.",
			"summary": "Study {{count}} items from {{skill}}. Estimated {{minutes}} minutes.",
			"summary_questionType": "Study {{count}} items from {{skill}}, {{questionType}}. Estimated {{minutes}} minutes.",
			"duration": "{{minutes}} min",
			"durationSelector": {
				"title": "Duration"
			},
			"levelSessions": {
				"rapidRecall": "Rapid recall",
				"purposefulPractice": "Purposeful practice",
				"focusFlow": "Focus flow",
				"itemsLabel": "{{level}} items",
				"itemsLabelGeneric": "items",
				"summaries": {
					"rapidRecall": "Get quick exposure to {{count}} {{level}} items you haven't answered yet to steadily grow your coverage. Estimated {{minutes}} minutes.",
					"purposefulPractice": "Work through a balanced set of {{count}} {{level}} items, starting with the material that needs the most work. Estimated {{minutes}} minutes.",
					"focusFlow": "Strengthen your weak spots with {{count}} {{level}} items you've answered with low or medium mastery. Estimated {{minutes}} minutes."
				},
				"summariesGeneric": {
					"rapidRecall": "Get quick exposure to {{count}} items you haven't answered yet to steadily grow your coverage. Estimated {{minutes}} minutes.",
					"purposefulPractice": "Work through a balanced set of {{count}} items, starting with the material that needs the most work. Estimated {{minutes}} minutes.",
					"focusFlow": "Strengthen your weak spots with {{count}} items you've answered with low or medium mastery. Estimated {{minutes}} minutes."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "In order to personalize your experience, start with a diagnostic quiz. The results from your diagnostic will be used to create your study plan."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Upgrade to premium",
		"unlockTitle": "Unlock your complete {{productName}} experience",
		"unlockDescription": "Unlock personalized practice designed around your remaining study time.",
		"readyTitle": "Be ready for your {{date}} exam",
		"tip": "Your personalized focus, premium identifies what to practice next and adjusts your study plan as you improve."
	},
	"purchase": {
		"success": {
			"headerTitle": "Thank you for your purchase!",
			"accessGranted": "Access to your {{name}} has been successfully granted",
			"studyPack": "Study-Pack",
			"practiceTest": "Practice Test",
			"combo": "Combo",
			"documentTitle": "Purchase",
			"summary_one": "Congratulations! The **product** below has been unlocked on your account. After pressing {{action}}, the context of your app will be changed to reflect the exam: **{{examName}}**. You can change this at any time from your account settings if you wish to study for a different exam or purchase a different subscription.",
			"summary_other": "Congratulations! The **{{count}} products** below have been unlocked on your account. After pressing {{action}}, the context of your app will be changed to reflect the exam: **{{examName}}**. You can change this at any time from your account settings if you wish to study for a different exam or purchase a different subscription.",
			"unlockedDuration": "Congratulations! You have unlocked **{{duration}}** access to the **{{name}}**. This will expire on **{{expiry}}**.",
			"storeNote": "Note: Study-Packs can only be accessed via our mobile apps. Please download the appropriate app for your device.",
			"actions": {
				"goToHome": "Go to home",
				"startDiagnostic": "Start {{label}}",
				"takeDiagnostic": "Take {{label}}",
				"takeFreeDiagnostic": "Take free diagnostic",
				"diagnosticLabel": "diagnostic"
			}
		},
		"checkout": {
			"headerTitle": "Complete Your Purchase"
		},
		"paywall": {
			"studyPackDialogTitle": "Upgrade your study plan",
			"defaultDialogTitle": "Upgrade your study plan",
			"practiceTestDialogTitle": "Unlock practice tests",
			"restorePurchaseDialogTitle": "Already purchased?",
			"restorePurchaseDialogSubheadingWeb": "If not, try this:",
			"restorePurchaseDialogBody": "If you already purchased this product and it's still locked, please try the following:\n\n1. Make sure you're logged into the proper account\n2. Make sure you have the correct product selected\n3. Make sure your subscription hasn't expired\n4. Make sure you've activated your subscription (check your junk mail)\n5. If you have an access code, [access code]({{baseUrl}}/redeem)\n\nIf none of these apply, please **click here**",
			"restorePurchaseDialogBodyWeb": "1. Make sure you're logged into the right email\n2. Make sure you have the correct **[exam selected](/account/settings)**\n3. Make sure your subscription hasn't expired\n\nIf none of these apply, please **contact support**",
			"accesDuration": {
				"yearPlan": "The **{{duration}}** plan provides extended access, giving you maximum flexibility to study at your own pace and thoroughly prepare for your exam.",
				"moreTime": "If you think you'll need more time to study, you can consider the **{{duration}}** plan.",
				"otherPlan": "The **{{duration}}** plan will grant you access until **{{expiryText}}**, which gives you enough time to study. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Upgrade",
				"unlock": "Unlock for {{price}}",
				"subscribe": "Subscribe for {{price}}",
				"extendAccess": "Extend access",
				"accessHere": "Access here",
				"redeemAccessCode": "Have an access code?",
				"restorePurchase": "Already purchased?",
				"restorePurchaseWeb": "Already purchased or have an access code?"
			},
			"subscriptionSummary": {
				"yearly": "Yearly subscription • Auto-renewing • Cancel anytime",
				"monthly": "Monthly subscription • Auto-renewing • Cancel anytime",
				"weekly": "Weekly subscription • Auto-renewing • Cancel anytime",
				"generic": "Auto-renewing subscription • Cancel anytime"
			},
			"planDuration": {
				"day_one": "{{count}} day",
				"day_other": "{{count}} days",
				"week_one": "{{count}} week",
				"week_other": "{{count}} weeks",
				"month_one": "{{count}} month",
				"month_other": "{{count}} months",
				"year_one": "{{count}} year",
				"year_other": "{{count}} years"
			},
			"recommendedPlan": {
				"plan": "We recommend the \"**{{duration}}**\" plan to best prepare for your exam on **{{date}}**",
				"subscription": {
					"yearly": "We recommend the **yearly subscription** for continuous access and preparation for your exam on **{{date}}**",
					"monthly": "We recommend the **monthly subscription** for continuous access and preparation for your exam on **{{date}}**",
					"weekly": "We recommend the **weekly subscription** for continuous access and preparation for your exam on **{{date}}**",
					"generic": "We recommend a **subscription** for continuous access and preparation for your exam on **{{date}}**"
				}
			},
			"disclaimer": "On confirmation of purchase you will be granted full access to the content of this product for the duration selected. When this period expires, you will lose access to the restricted content. If you wish to extend your access for any reason (e.g. you moved your test date), you can add time via additional in-app purchases. For more information, see our [Terms of Service and Privacy Policy](https://memorang.com/legal)."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "Based on {{numItems}} {{item}} answered across {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "This shows your progress across {{count}} {{type}}. It's based on {{itemCount}} {{item}} you've answered so far."
		},
		"needsImprovement": {
			"title": "Needs improvement",
			"subtitle": "Recommended {{type}} for you to improve upon",
			"cta": "Study now"
		},
		"mastery": {
			"high": "Mastered",
			"medium": "Almost there",
			"low": "Needs work",
			"count": "{{count}} {{item}} answered",
			"zeroTooltip": "No {{label}} items yet out of {{total}} items answered",
			"highTooltip": "You've mastered {{count}} of {{total}} {{item}} answered",
			"mediumTooltip": "You're making progress on {{count}} of {{total}} {{item}} answered",
			"lowTooltip": "You need more practice with {{count}} of {{total}} {{item}} answered"
		},
		"stats": {
			"completion": "Completion",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "You've completed {{completed}} out of {{total}} {{item}}"
		},
		"exams": {
			"title": "Practice tests",
			"subtitle_one": "Based on {{count}} completed assessment",
			"subtitle_other": "Based on {{count}} completed assessments"
		},
		"summary": {
			"title": "Learning summary",
			"subtitle": "Based on {{count}} {{item}} answered",
			"tooltip": "This summary shows your mastery levels and completion progress across {{count}} total {{item}}. Your performance is measured through practice sessions, assessments, and study activities.",
			"mastery": "Mastery",
			"quickStats": "Quick stats"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}} proficiency",
			"proficiencyCardTooltip": "You are currently performing at a {{level, lowercase}} {{skill, lowercase}} level",
			"itemTypesCardSubtitle_one": "{{count}} item type",
			"itemTypesCardSubtitle_other": "{{count}} item types",
			"itemTypesCardTitle": "{{skill}} items",
			"itemTypeLevelTooltip": "You are currently performing at a {{level, lowercase}} {{skill, lowercase}} level on “{{itemType}}” question types",
			"itemTypesFallbackTitle": "Item types",
			"itemTypesEmptyTitle": "Item types unavailable",
			"itemTypesEmptySubtitle": "We couldn't find item types for this skill. Go back to Progress and try again.",
			"itemTypesEmptyCta": "Back to progress",
			"notAnswered": "Not answered",
			"answeredSubtitle_one": "Based on {{count}} item answered",
			"answeredSubtitle_other": "Based on {{count}} items answered",
			"responsesSubtitle_one": "Based on {{count}} response",
			"responsesSubtitle_other": "Based on {{count}} responses",
			"testsTakenSubtitle_one": "Based on {{count}} test taken",
			"testsTakenSubtitle_other": "Based on {{count}} tests taken",
			"startFirstTest": {
				"title": "Let's get started",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} items",
				"guidance": {
					"diagnostic": "Start with a diagnostic to find your strengths and tailor your study plan.",
					"sectional": "A sectional test focuses on one part of the exam, so you get a score in a shorter sitting.",
					"fullMock": "A full mock test mirrors the real exam end to end and gives you the most complete score."
				}
			},
			"noScoresTitle": "No {{skill, lowercase}} scores yet",
			"noScoresSubtitle": "Take your first test to see your estimated score and task breakdown.",
			"noScoresCta": "Start",
			"noScoresCardSubtitle": "Based on the tests you take",
			"personalBestLabel": "Your personal best",
			"latestLabel": "Your latest",
			"examCountdown_one": "Your exam is in {{count}} day",
			"examCountdown_other": "Your exam is in {{count}} days",
			"greeting": {
				"none": "Let's get started, {{firstName}}! 🚀",
				"low": "Good start, {{firstName}} — keep going! 💪",
				"medium": "Keep it up, {{firstName}}! 💪",
				"high": "You're almost there, {{firstName}}! 🎯"
			},
			"greetingNoName": {
				"none": "Let's get started! 🚀",
				"low": "Good start — keep going! 💪",
				"medium": "Keep it up! 💪",
				"high": "You're almost there! 🎯"
			},
			"stats": {
				"untilExam": "Exam date",
				"itemsAnswered": "Items answered",
				"responsesAnswered": "Responses"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Incorrect passcode",
		"incorrectPassword": "Incorrect password. Please try again.",
		"passwordPlaceholder": "Enter password",
		"emailPlaceholder": "e.g., dave@gmail.com",
		"verify": {
			"openEmail": "Open email to continue",
			"signInCta": "Verifying your account...",
			"signUpCta": "Creating your account...",
			"contactSupport": "Can’t see the email? Check your spam folder or",
			"contactSupportLink": "Contact us",
			"resendMagicLink": "Resend magic link",
			"resendMagicLinkIn": "Resend magic link in {{time}}",
			"signInBody": "You're almost there! Verifying your details to securely sign in to the {{appName}} app.",
			"signUpBody": "Almost done! We're verifying your details to create your new {{appName}} app account.",
			"magicLinkEmail": "We've sent a magic link to **{{email}}**\nClick the link in your email to securely sign in.",
			"magicLinkEmailExpiry": "This link expires in 10 minutes",
			"confirmEmail": "Confirm your email",
			"redirectingToApp": "Redirecting to the {{appName}} app...",
			"appNotOpen": "App did not open? Click the button below to open the associated application",
			"openApp": "Open {{appName}} app",
			"installAppPrompt": "If nothing happens, make sure you have the {{appName}} app installed on your device",
			"verifyAccountTitle": "Verify your account",
			"emailResent": "Magic link sent to {{email}}\nPlease check your inbox, including spam.",
			"verificationLinkExpired": "Verification link expired",
			"verificationLinkExpiredBody": "Verification links expire after 10 minutes and can only be used once. \nYou can request a new one by logging in again",
			"accountSetupTimeoutTitle": "Unable to finish signing in",
			"accountSetupTimeoutBody": "Your account is taking longer than expected to set up. Please try logging in again or contact support if this continues.",
			"loginAgain": "Login again",
			"contactSupportExpiredLink": "If this issue continues to persist, let us know",
			"successTitle": "You are now signed in on another tab",
			"successBody": "Close this tab or continue from here",
			"successCtaLabel": "Continue here",
			"needHelpLabel": "Need help?",
			"contactSupportButton": "Contact support"
		},
		"contactSupportDialog": {
			"title": "Trouble logging in?",
			"body": "Please get in touch with our customer support if you have trouble logging in or try again",
			"cta": "Email Us"
		},
		"emailInstruction": {
			"default": "If you do not receive an email, check your junk, spam, and recently deleted folders",
			"edu": "If you do not receive an email, check your junk, spam, and recently deleted folders, or contact your IT administrator"
		},
		"createSessionLoader": {
			"configuringSession": "Configuring session",
			"analyzingMastery": "Analyzing mastery",
			"loadingContent": "Loading content"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "What should we call you?",
				"description": "Your username appears on public leaderboards while your name stays private.",
				"usernameLabel": "Username",
				"firstNameLabel": "First name",
				"lastNameLabel": "Last name",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Avatars are automatically generated based on your username.",
				"profileSaveFailed": "We couldn't save your profile. Please try again."
			},
			"testDate": {
				"cta": "Continue"
			},
			"examDate": {
				"daysAway": "That gives us {{value}} days. We will prioritize your weakest areas immediately."
			},
			"skills": {
				"chooseAll": "Choose all that apply"
			},
			"plan": {
				"recommended": "Recommended"
			},
			"toeicLevelOverview": {
				"title": "Everyone starts somewhere.",
				"description": "Practice helps you build mastery at one level before naturally growing into the next.",
				"illustrationLabel": "Progression from Basic (A1–A2) to Intermediate (B1–B2) to Proficient (C1).",
				"levels": {
					"basic": {
						"name": "Basic",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Intermediate",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Proficient",
						"band": "C1"
					}
				},
				"progression": {
					"title": "How you'll progress",
					"practiceSessions": "Practice recommended sessions",
					"buildMastery": "Build mastery at your current level",
					"growToward": "Continue growing toward Proficient"
				},
				"levelDetails": {
					"title": "What each level means",
					"scoreRange": "{{band}} · score {{min}}–{{max}}",
					"basic": {
						"name": "Basic User",
						"summary": "Simple workplace English",
						"examples": {
							"forms": "Forms & notices",
							"instructions": "Instructions",
							"announcements": "Short announcements"
						}
					},
					"intermediate": {
						"name": "Intermediate User",
						"summary": "Everyday workplace communication",
						"examples": {
							"emails": "Emails & conversations",
							"customers": "Customer interactions",
							"followUps": "Meeting follow-ups"
						}
					},
					"proficient": {
						"name": "Proficient User",
						"summary": "Professional & advanced English",
						"examples": {
							"reports": "Complex reports & presentations",
							"negotiations": "Nuanced negotiations",
							"highStakes": "High-stakes professional contexts"
						}
					}
				},
				"disclaimer": "TOEIC Link scores are CEFR-aligned guidelines, not absolute cut scores. Reading and Listening progress independently — you may reach different levels in each skill."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnostic: {{title}}",
					"body": "{{count}} items to find where to focus",
					"duration": "{{minutes}} min"
				},
				"homeChoice": {
					"title": "Explore on my own",
					"body": "Not ready to start, I'll explore the app first"
				}
			}
		},
		"common": {
			"changeLater": "You can change this later"
		},
		"actions": {
			"previous": "Previous",
			"finish": "Finish",
			"start": "Start",
			"continue": "Continue",
			"stepIndicator": "Step {{step}} of {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "About you"
		},
		"exam": {
			"title": "Your exam"
		},
		"subscriptions": {
			"title": "Products",
			"redeem": {
				"title": "Redeem purchase"
			},
			"extend": {
				"cta": "Extend"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Set your goal exam date",
			"description": "This date is only to guide your study schedule within the app. It does not affect your official exam registration.",
			"dismissCta": "Not now",
			"confirmCta": "Set exam date"
		}
	},
	"account": {
		"title": "Account settings",
		"currentExam": "Current exam",
		"subscriptions": "Products",
		"examDate": "Exam date",
		"examDateUpdated": "Exam date set to {{date}}",
		"selectDate": "Select date",
		"appearance": "Appearance",
		"features": "Features",
		"audioPlaybackTest": "Show test audio playback dialog",
		"theme": "Theme",
		"selectTheme": "Choose theme",
		"themeOptions": {
			"system": "System",
			"light": "Light",
			"dark": "Dark"
		},
		"accountInfo": "Account",
		"username": "Username",
		"name": "Name",
		"nameNotSet": "Not set",
		"save": "Save",
		"editUsername": {
			"title": "Edit username"
		},
		"editName": {
			"title": "Edit name"
		},
		"email": "Email",
		"dev": "Dev",
		"sandbox": "Sandbox",
		"redoOnboarding": "Redo onboarding",
		"about": "About",
		"termsOfService": "Terms of service",
		"privacyPolicy": "Privacy policy",
		"aiToolsTos": "AI tools terms of use",
		"support": "Support",
		"supportEmailBody": "I am reaching out to you because I need assistance with [  ]\n\n\n\nHere is some helpful information to help resolve things faster: \n\nUsername associated with the account (found in settings when logged into the app):\n{{username}}\n\nEmail associated with my order (found in settings when logged into the app):\n{{email}}\n\nOrder Number (usually found in the receipt email that triggered upon purchase):\n\nIs there a chance a different name or email was used when the product was actually purchased? If so please provide them:\n\nFirst and last name:\n\nEmail:",
		"contactSupport": "Contact support",
		"signOut": "Sign out",
		"signOutConfirmation": "Are you sure you want to sign out?",
		"deleteAccount": "Delete account",
		"platform": "Platform",
		"partnerships": "Partnerships",
		"validUntil": "Expires on {{date}}",
		"extendValidity": "Extend access",
		"redeemPurchase": "Redeem purchase",
		"redeemPurchaseNoneFound": "No purchases available to redeem",
		"redeemPurchaseCheckFailed": "Couldn't check purchases. Please try again.",
		"purchases": "Purchases",
		"frequentlyAskedQuestions": "Frequently asked questions",
		"deleteFeedbackForm": {
			"placeholder": "Feedback"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "More data needed",
		"proficiencyLevelPendingTooltip": "Answer more {{label}} items to estimate your level",
		"on": "on",
		"gotIt": "Got it",
		"goBack": "Go back",
		"topic": "topic",
		"itemCount_one": "{{count, number}} item",
		"itemCount_other": "{{count, number}} items",
		"examCount_one": "{{count}} exam",
		"examCount_other": "{{count}} exams",
		"questionCount_one": "{{count}} question",
		"questionCount_other": "{{count}} questions",
		"item_one": "item",
		"item_other": "items",
		"and": "and",
		"this": "this",
		"of": "of",
		"knowMore": "Know more",
		"proficiency": "proficiency",
		"didNotAnswer": "Items that you have not yet answered",
		"notAnswered": "Not answered",
		"attempted": "attempted",
		"attempt": "attempt",
		"activity": "activity",
		"performance": "Performance",
		"estimatedProficiency": "Estimated proficiency",
		"details": "details",
		"keepPracticing": "keep practicing!",
		"leaveFeedback": "Leave feedback",
		"copiedToClipboard": "Copied to clipboard",
		"eg": "e.g.",
		"set": "set",
		"hint": "hint",
		"itemType": "item type",
		"minute": "minute",
		"minutes": "{{count}} minutes",
		"hour": "hour",
		"hours": "{{count}} hours",
		"continue": "Continue",
		"unlock": "Unlock",
		"cancel": "Cancel",
		"view": "View",
		"switch": "Switch",
		"update": "Update",
		"ok": "Ok",
		"yes": "Yes",
		"free": "Free",
		"answered": "Answered",
		"correct": "Correct",
		"incorrect": "Incorrect",
		"marked": "Marked",
		"unmarked": "Not marked",
		"skipped": "Skipped",
		"skill_one": "skill",
		"skill_other": "skills",
		"word_one": "word",
		"word_other": "words",
		"submitResponse": "Submit response",
		"viewDetails": "View details",
		"sec_one": "sec",
		"sec_other": "secs",
		"point_one": "point",
		"point_other": "points",
		"week": "Week",
		"month": "Month",
		"year": "Year",
		"day": "Day",
		"selectTestDate": "Select exam date",
		"points": "Points",
		"viewAll": "View all",
		"timeline": "Timeline",
		"save": "Save",
		"filters": {
			"selectAll": "Select all",
			"deselectAll": "Deselect all",
			"selectedCount": "{{count}} selected",
			"expandSection": "Expand {{section}}",
			"collapseSection": "Collapse {{section}}"
		},
		"showMore": "Show more",
		"showLess": "Show less",
		"expandA11yLabel": "Expand description",
		"collapseA11yLabel": "Collapse description",
		"done": "Done",
		"clearAll": "Clear all",
		"clear": "Clear",
		"datePicker": {
			"title": "Select date",
			"enterDateLabel": "Enter date",
			"enterDateRangeLabel": "Enter dates",
			"dateLabel": "Date",
			"startDateLabel": "Start date",
			"endDateLabel": "End date",
			"dateRequiredError": "Date is required",
			"invalidDateFormatError": "Invalid date format. Please use MM/DD/YYYY",
			"startAfterEndError": "Start date cannot be after end date",
			"endBeforeStartError": "End date cannot be before start date",
			"minDateError": "Date must be {{date}} or later",
			"maxDateError": "Date must be {{date}} or earlier",
			"dateRangeError": "Date must be between {{startDate}} and {{endDate}}",
			"setDateCta": "Set date",
			"nextCta": "Next",
			"setTimeCta": "Set time"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} of learners chose this answer.",
		"choiceCorrectA11yLabel": "Correct answer",
		"choiceIncorrectA11yLabel": "Incorrect answer",
		"choiceNotSelectedA11yLabel": "Not selected",
		"moreItemsAlertDialog": {
			"title": "Additional Items",
			"cta": "Got it"
		},
		"results": {
			"followUps": {
				"title": "Follow-ups"
			},
			"summary": {
				"sessionAnalysis": "Session Analysis",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} items",
				"skilledItemCount_one": "{{count}} {{skills}} item",
				"skilledItemCount_other": "{{count}} {{skills}} items",
				"levelPhrase_one": "from the {{levels}} level",
				"levelPhrase_other": "from the {{levels}} levels",
				"message": "<bold>Great job!</bold> You've just completed {{itemPhrase}} in {{timeTaken}}.",
				"messageWithLevels": "<bold>Great job!</bold> You've just completed {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) in {{timeTaken}}.",
				"proficiencyEstimateReady": "Your estimated {{skill}} level is <bold>{{currentLevel}}</bold>. You are now ready to target <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Your estimated {{skill}} level is <bold>{{currentLevel}}</bold>. Keep practicing before continuing to <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Your estimated {{skill}} level is <bold>{{currentLevel}}</bold>. Outstanding work!",
				"mixedLevel": "Mixed",
				"overallScore": "Overall Score",
				"stats": {
					"itemsAttempted_one": "Item answered",
					"itemsAttempted_other": "Items answered",
					"pointsEarned_one": "Point earned",
					"pointsEarned_other": "Points earned",
					"answeredCorrectly": "Answered correctly",
					"timeTaken": "Time taken",
					"target": "Target",
					"ofTotal": "of {{total}}",
					"ofPointsTotal": "of {{total}}",
					"skill": "Skill",
					"skills": "Skills",
					"questionType": "Question type",
					"questionTypes": "Question types",
					"proficiencyLevel": "Proficiency level",
					"proficiencyLevels": "Proficiency levels"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "Audio starts in {{seconds}}s",
			"audioStartsInPlayOnce": "Audio starts in {{seconds}}s, plays once only",
			"videoStartsIn": "Video starts in {{seconds}}s",
			"videoStartsInPlayOnce": "Video starts in {{seconds}}s, plays once only",
			"recordingIn": "Recording in {{seconds}}s"
		},
		"timeOverrunBanner": {
			"message": "Time's up. On the real exam, anything after this would not be scored. You can keep practicing."
		},
		"attributes": {
			"stimulus": "stimulus"
		},
		"stimulusTypes": {
			"reading": "Reading",
			"listening": "Listening",
			"speaking": "Speaking",
			"writing": "Writing",
			"image": "Image"
		},
		"masteryLevels": {
			"belowBasic": "Below Basic",
			"basic": "Basic",
			"belowLowIntermediate": "Below Low-Intermediate",
			"lowIntermediate": "Low-Intermediate",
			"highIntermediate": "High-Intermediate",
			"advanced": "Advanced",
			"proficiencySubtitle": "On the {{trademark}}, this maps to a score of **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "{{skill}} section info",
			"infoSectionText": {
				"Reading": "The {{trademark}} Reading section assesses how well you can read and understand written materials used in an academic environment. It includes two reading passages, each approximately 700 words long, with 10 questions per passage. It should take about 35 minutes to complete the Reading section.",
				"Listening": "The {{trademark}} Listening section is designed to measure your ability to understand conversations and lectures in English. It includes listening for: basic comprehension, understanding the speaker's attitude and degree of certainty, and connecting information. It should take about 36 minutes to complete the Listening section.",
				"Speaking": "The {{trademark}} Speaking section measures your ability to speak English effectively in academic settings. The four questions/tasks resemble real-life situations you might encounter both in and outside of a classroom. It should take about 16 minutes to complete the Speaking section.",
				"Writing": "The {{trademark}} Writing section measures your ability to write in English in an academic setting, and to present your ideas in a clear, well-organized way. You'll type your responses on a computer keyboard and it should take about 29 minutes to complete the Writing section."
			}
		},
		"itemTypes": {
			"MCSS": "Multiple choice single select",
			"MCSSH": "Multiple choice single select highlight",
			"MCMS": "Multiple choice multiple select",
			"MCMSH": "Multiple choice multiple select highlight",
			"INSERT_TEXT": "Insert text",
			"MATCH_MS": "Match multiple select",
			"MCSSM": "Multiple choice single select match",
			"MCMSM": "Multiple choice multiple select match",
			"MCGS": "Multiple choice gap select",
			"MCOS": "Multiple choice order select",
			"LISTENING_REPLAY": "Listening replay",
			"AUDIO_INPUT": "Audio input",
			"ACADEMIC_DISCUSSION_RESPONSE": "Academic discussion response",
			"INTEGRATED_WRITING_RESPONSE": "Integrated writing response"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} of {{total}}",
			"questionOfTotal": "Question {{current}} of {{total}}",
			"stimulusCorrespondsToNextItems": "The following stimulus corresponds to the next {{total}} items",
			"passage": "Passage",
			"lecture": "Lecture",
			"professorsQuestion": "Professor's Question",
			"listen": "Listen",
			"openPassage": "Open passage",
			"backToItem": "Back to item",
			"notYetInserted": "Not yet inserted",
			"insertedAtPosition": "Inserted at position #{{position}}"
		},
		"hint": {
			"show": "Show hint"
		},
		"navigation": {
			"next": "Next",
			"exit": "Exit",
			"saveAndExit": "Save & Exit",
			"previous": "Prev",
			"skip": "Skip",
			"finish": "Finish",
			"help": "Help",
			"about": "Question tips",
			"questionsButtonLabel": "Question navigation",
			"questionsButtonTooltip": "Jump to any question or review marked ones",
			"questionsButtonActiveFiltersA11y": "Active filters: {{count}}",
			"recordingInProgressTooltip": "You cannot navigate away from this item while recording is in progress",
			"questionNotReachedTooltip": "You haven't reached this question yet"
		},
		"questionTips": {
			"hideFutureLabel": "Don't show tips automatically"
		},
		"toolbar": {
			"calculatorTooltip": "Open calculator",
			"highlightTooltip": "Select text to highlight important information for easy reference",
			"markTooltip": "Flag this question to revisit later before submitting",
			"unmarkTooltip": "Click to unmark this question"
		},
		"summary": {
			"viewFullInsights": "View full insights",
			"targetTooltip": "The performance target for this session."
		},
		"stats": {
			"skill": "Skill",
			"answered": "Answered",
			"speed": "Speed",
			"duration": "Duration",
			"duration_tooltip": "The length of your recorded response: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Confidence",
			"pointsEarned": "Points",
			"word": "Word",
			"words": "Words",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "It took you {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) to read and respond to this item",
			"skill_tooltip": "The skill area assessed for this item: {{skill}}",
			"answered_correct_tooltip": "Your submitted response was correct",
			"answered_incorrect_tooltip": "Your submitted response was incorrect",
			"skipped_tooltip": "You did not submit a response for this item",
			"words_tooltip": "Word count in your written response: {{count}}",
			"word_tooltip": "Word count in your written response: {{count}}",
			"confidence_tooltip": "How confident you were when you submitted your response",
			"points_earned_tooltip_one": "You earned {{points}} point out of {{maximumScore}} maximum points for this item",
			"points_earned_tooltip_other": "You earned {{points}} points out of {{maximumScore}} maximum points for this item",
			"challengers_tooltip": "Number of learners who answered this item before you: {{count}}",
			"learning_mode_points_tooltip": "Points earned for this attempt: +{{xp}} XP",
			"pts_earned_tooltip": "Points earned for this attempt: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Expand breakdown"
		},
		"explanation": {
			"title": "Explanation",
			"feedback": "Feedback",
			"skippedFeedbackNotice": "You skipped this question, so personalized feedback wasn't generated."
		},
		"followUps": "Follow-ups",
		"suggestCorrection": "Suggest correction",
		"answer": {
			"correct": "Correct",
			"incorrect": "Incorrect",
			"skipped": "Skipped"
		},
		"confidence": {
			"high": "High",
			"medium": "Medium",
			"low": "Low"
		},
		"endDialog": {
			"title": "Finish session early?",
			"confirmEndDiagnostic": "Are you sure you want to end your session? All progress will be lost and you'll need to start over.",
			"confirmEnd": "You still have {{num}} {{itemLabel}} left. You can finish now or keep studying to complete them.",
			"confirmEndNoAnswer": "You haven’t answered any questions yet. Are you sure you want to finish now?",
			"confirmEndNoAnswerPositive": "Keep studying",
			"confirmEndNoAnswerNegative": "Finish now"
		},
		"permissionDialog": {
			"title": "Microphone access needed",
			"descriptionWeb": "Speaking practice uses your microphone. Your browser is blocking access for this site — click the permissions icon next to the web address, allow the microphone, then try again.",
			"descriptionMobile": "Speaking practice uses your microphone. Allow microphone access in your device settings to continue.",
			"promptDescriptionWeb": "Speaking practice uses your microphone. Request permission and choose Allow when your browser asks.",
			"blockedDescriptionWeb": "Microphone access is blocked for this site. Click the icon next to the web address, allow the microphone, then request permission again.",
			"ok": "OK",
			"cancel": "Cancel",
			"openSettings": "Open settings",
			"requestPermission": "Request permission",
			"dismissAndExit": "Dismiss & Exit",
			"learnMore": "Learn more"
		},
		"audioPlaybackTestDialog": {
			"title": "Test audio playback",
			"description": "The {{appName}} app includes multiple audio playback features, such as those in stimuli, test items, and text-to-speech. To ensure the best experience, please test your audio below. Once you've confirmed it's working, proceed.",
			"troubleshooting": {
				"title": "Troubleshooting audio issues",
				"volumeTitle": "Check device volume",
				"volumeDescriptionWeb": "Adjust volume using keyboard controls or system volume settings in menu/taskbar",
				"volumeDescriptionMobile": "Use device volume buttons or adjust in system settings",
				"outputTitle": "Verify audio output device",
				"outputDescription": "In case of headphones, ensure they are properly connected and selected as the active output device",
				"browserTitle": "Check browser tab audio",
				"browserDescription": "Look for muted speaker icon next to tab title and unmute if present."
			},
			"skipCheck": "Skip this check next time",
			"workingButton": "Confirm audio",
			"textToHear": "You should hear: {{text}}"
		},
		"overall": "Overall",
		"subskills": {
			"content": {
				"title": "Content"
			},
			"languageUse": {
				"title": "Language Use"
			},
			"organizationAndDevelopment": {
				"title": "Organization and Development"
			},
			"topicDevelopment": {
				"title": "Topic Development"
			},
			"delivery": {
				"title": "Delivery"
			}
		},
		"finalizing": {
			"title": "Finalizing your results",
			"gradingProgress": "Grading responses..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "A speaking task where the learner repeats a sentence they heard as accurately as possible.",
			"Read Aloud": "A speaking item where the learner reads a passage aloud for assessment.",
			"Describe Image": "A speaking task where the learner describes a visual stimulus in detail.",
			"Write Essay": "A constructed-response task requiring a structured essay on a given prompt.",
			"Retell Lecture": "A speaking task where the learner summarizes a lecture or talk they listened to.",
			"Summarize Group Discussion": "A listening task where the learner summarizes a multi-speaker discussion.",
			"Answer Short Question": "A brief speaking task answering a single short question with a concise response.",
			"Respond to a Situation": "A speaking task where the learner responds appropriately to a described scenario.",
			"Summarize Written Text": "A reading task where the learner summarizes a passage in their own words.",
			"Reorder Paragraph": "A reading task where the learner arranges scrambled paragraphs into the correct order.",
			"Fill in the Blanks (Dropdown)": "A reading task where each blank is completed from a dropdown of options.",
			"Fill in the Blanks (Type In)": "A listening task where the learner types the missing word or short phrase.",
			"Fill in the Blanks (Drag and Drop)": "A reading task where missing words are filled by dragging options into blanks.",
			"Multiple Choice, Single Answer": "A multiple-choice item where the learner selects one correct answer.",
			"Multiple Choice, Single Answer (Reading)": "A reading multiple-choice item where the learner selects one correct answer.",
			"Multiple Choice, Single Answer (Listening)": "A listening multiple-choice item where the learner selects one correct answer.",
			"Multiple Choice, Multiple Answers": "An item where the learner may select more than one correct answer.",
			"Multiple Choice, Multiple Answers (Reading)": "A reading item where the learner may select more than one correct answer.",
			"Multiple Choice, Multiple Answers (Listening)": "A listening item where the learner may select more than one correct answer.",
			"Summarize Spoken Text": "A listening task where the learner writes a summary of what they heard.",
			"Highlight Correct Summary": "A listening task where the learner highlights the summary that best matches the audio.",
			"Select Missing Word": "A listening cloze-style task where the learner chooses the missing word.",
			"Highlight Incorrect Words": "A listening task where the learner highlights words in the transcript that differ from the audio.",
			"Write from Dictation": "A listening task where the learner transcribes a sentence they hear."
		}
	},
	"report": {
		"readFullInsights": "Read full insights",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Started at {{time}}",
		"itemTypesTitle": "Item types breakdown",
		"itemTypesFilterAll": "All",
		"questionTypeCardTitle": "{{skill}} item types breakdown",
		"questionTypeCardSubtitle_one": "Based on {{count}} {{skill}} item type in this session",
		"questionTypeCardSubtitle_other": "Based on {{count}} {{skill}} item types in this session",
		"questionTypeCardAltSubtitle_one": "Based on {{count}} item type in this session",
		"questionTypeCardAltSubtitle_other": "Based on {{count}} item types in this session",
		"questionTypeRowSubtitle_zero": "No items answered",
		"questionTypeRowSubtitle_one": "{{count}} item answered",
		"questionTypeRowSubtitle_other": "{{count}} items answered",
		"itemTypeDetail": {
			"review_one": "Review item",
			"review_other": "Review items",
			"stats": {
				"answered_one": "Item answered",
				"answered_other": "Items answered",
				"avgTime": "Avg time per item"
			}
		},
		"reviewAnswersDialog": {
			"title": "Review Answers",
			"sections": {
				"skills": "Skills",
				"questionTypes": "Question types",
				"proficiency": "Proficiency",
				"performance": "Performance"
			},
			"summaryNone": "Select filters with items to continue.",
			"summaryAll_one": "Review all {{count}} answer.",
			"summaryAll_other": "Review all {{count}} answers.",
			"summaryFiltered_one": "Review {{count}} answer matching {{filters}}.",
			"summaryFiltered_other": "Review {{count}} answers matching {{filters}}.",
			"reviewAnswers_one": "Review {{count}} answer",
			"reviewAnswers_other": "Review {{count}} answers",
			"more": "{{count}} more"
		},
		"itemDetail": {
			"title": "Review my answers",
			"filterAll": "All",
			"filterCorrect": "Correct",
			"filterIncorrect": "Incorrect",
			"filterMarked": "Marked",
			"emptyTitle": "No matching items",
			"emptyDescription": "None of your session items match the selected filter ({{filter}}). Try adjusting or clearing filters to view more results.",
			"emptyCta": "Clear filters"
		},
		"answerCardTitle": "Items answered",
		"answerCardSubtitle_one": "See how you did across all questions",
		"answerCardSubtitle_other": "See how you did across all {{count}} questions",
		"skillsBreakdown": {
			"title": "Skills Breakdown",
			"subtitle_one": "Based on {{count}} item",
			"subtitle_other": "Based on {{count}} items"
		},
		"studyPack": "Study-Pack",
		"practiceTestCompleted": "Practice test completed",
		"studySessionCompleted": "Study session completed",
		"diagnosticSessionCompleted": "Diagnostic session completed",
		"timeElapsed": "Time elapsed",
		"stats": {
			"answered": "ANSWERED",
			"time elapsed": "TIME ELAPSED",
			"avg speed": "AVG SPEED",
			"hints used": "HINT USED"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Fantastic job—keep striving for excellence!",
				"highIntermediate": "You're doing great—keep honing your strengths!",
				"lowIntermediate": "Your progress is steady—keep it up!",
				"basic": "Keep working to boost your abilities!"
			},
			"infoText": "You completed **{{numActivities}} {{activityLabel}}** to practice your {{skillsText}} {{skills}}. {{skillDetails}}. Overall, you earned **{{numPointsEarned}} out of {{numTotalPoints}} points**, suggesting a **{{compositeLevel}} proficiency** across {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "You completed **{{itemCount}} {{itemLabel}}** focused on your **{{skill_1}}** skill. You scored **{{skill_1_score}} out of {{skill_1_total}}**, indicating a **{{proficiency}}** proficiency. {{compositeFeedback}}",
			"infoText.multiSkill": "You completed **{{itemCount}} {{itemLabel}}**, practicing your **{{skills_text}}** skills. {{skill_details}} Overall, you earned **{{overall_score}} out of {{overall_total}} points**, suggesting a **{{overall_proficiency}}** proficiency across these skills. {{compositeFeedback}}",
			"skillDetails": "In **{{skill}}**, you scored **{{score}} out of {{total}}**, showing a **{{proficiency}}** proficiency."
		},
		"actions": {
			"goToHome": "Go to homepage",
			"studyMore": "Study more",
			"studyFree": "Study free {{tagTypes}}",
			"reviewAnswers": "Review answers"
		},
		"nextAction": {
			"title": "Recommended: {{focus}} practice",
			"dialog": {
				"title": "Recommended study session",
				"subtitle": "Focus on your gap areas"
			},
			"fallback": {
				"title": "Keep practicing",
				"description": "Build a study session around the areas you want to work on next."
			}
		},
		"premium": {
			"upgradeCta": "Upgrade to premium"
		},
		"disclaimer": {
			"title": "Disclaimer",
			"summativeBody": "Practice test scores are an estimate and do not guarantee the same result in a live {{examName}} test."
		},
		"performance": {
			"title": "Performance",
			"subtitle": "Based on {{count}} items",
			"correct": "Correct",
			"correctItems": "{{count}} items",
			"incorrect": "Incorrect",
			"incorrectItems": "{{count}} items"
		},
		"mastery": {
			"performanceTitle": "Performance",
			"sessionMasteryTitle": "Estimated proficiency",
			"subtitle_assessment": "Based on all {{count}} {{item}} from this assessment",
			"subtitle_session": "Based on all {{count}} {{item}} from this session"
		},
		"sessionAnalysis": {
			"title": "Session analysis",
			"subtitle": "Personalized analysis and recommendations",
			"viewFullAnalysis": "View analysis",
			"feedbackDialog": {
				"body": "We release updates almost every day and are determined to improve. Would you mind leaving feedback?",
				"placeholder": "Enter your feedback here",
				"cta": "Send feedback",
				"successMessage": "Feedback submitted. Thank you!",
				"feedbackLimitError": "Feedback must be at least 10 characters long"
			},
			"menuActions": {
				"copy": "Copy",
				"altCopy": "Copy summary text",
				"altPositiveFeedback": "This was helpful",
				"positiveFeedback": "Good response",
				"negativeFeedback": "Bad response",
				"reportIssue": "Report",
				"altReportIssue": "Report this response",
				"emailSummary": "Email summary text",
				"emailAlreadySent": "Email already sent",
				"copiedAnalysis": "Copied analysis to clipboard",
				"emailSent": "Email sent to {{email}}, If you do not receive an email, check your junk, spam, and recently deleted folders",
				"emailFailed": "Failed to send email to {{email}}",
				"emailInstructionMessage": "If you do not receive an email, check your junk, spam, and recently deleted folders, or contact your IT administrator"
			}
		}
	},
	"feedback": {
		"successMessage": "Feedback submitted. Thank you!"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "What do you like? What could be improved? We make daily improvements to the platform and our team reads every piece of feedback. Thank you!",
			"title": "Share your feedback",
			"body": "What do you like? What could be improved? We make daily improvements to the platform and our team reads every piece of feedback. **Thank you!**",
			"positiveBody": "We're glad this was helpful! Let us know **what you liked.**",
			"negativeBody": "Help us understand what went wrong so we can **improve our responses.**",
			"placeholder": "Enter feedback",
			"cta": "Send feedback"
		},
		"report": {
			"title": "Submit report",
			"body": "Help us understand what’s wrong with this response",
			"cta": "Submit report"
		},
		"suggestCorrection": {
			"title": "Suggest a correction",
			"body": "Help us improve the accuracy of this content by **reporting any errors.**",
			"cta": "Submit"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Inaccurate",
					"description": "The response contains incorrect information"
				},
				"notHelpful": {
					"title": "Not helpful",
					"description": "The response didn't address my question"
				},
				"incomplete": {
					"title": "Incomplete",
					"description": "The response is missing important details"
				},
				"hardToUnderstand": {
					"title": "Hard to understand",
					"description": "The response was confusing or unclear"
				},
				"other": {
					"title": "Other",
					"description": "Something else"
				}
			},
			"report": {
				"misinformation": {
					"title": "Misinformation",
					"description": "The response contains false or misleading information"
				},
				"harmfulContent": {
					"title": "Harmful or Offensive Content",
					"description": "Hate speech, harassment, or inappropriate language"
				},
				"violatesPolicies": {
					"title": "Violates Policies",
					"description": "Spam, self-promotion, or illegal content"
				},
				"other": {
					"title": "Other",
					"description": "Specify what went wrong in your own words"
				}
			}
		},
		"faqs": {
			"title": "Frequently asked questions",
			"body": "Here are some of the most frequently asked questions about the app. If you have any other questions, please contact us at support@memorang.ai"
		},
		"delete": {
			"title": "Delete account",
			"body": "We're sorry to see you go and wish you the best of luck on your academic and professional journey!",
			"options": "Too expensive|Already took my test|Didn't like the content|Missing features/functionality|Other",
			"confirmdelete": {
				"title": "Confirm Account Deletion",
				"cta": "Delete",
				"errorMessage": "Sorry, that email doesn't match this account. Please try again",
				"successMessage": "Account deleted successfully!",
				"validEmail": "Please enter a valid email address"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Tap to record your response",
		"responseAudioUnavailable": "Response audio is unavailable for playback",
		"recording": "Recording",
		"recordingCompleted": "Recording Completed",
		"getReady": "Get ready",
		"timeIsUp": "Time is up. Your response was not recorded.",
		"alert": {
			"title": "Max duration reached",
			"body": "The recording has been stopped because it reached the maximum duration of {{maxDuration}} seconds."
		},
		"uiElementPressed": "Recording stopped - stimulus opened during an active recording."
	},
	"writing": {
		"placeholder": "Write your response here...",
		"wordCount": "{{count}} {{word}}",
		"title": "Your response",
		"submit": "Submit",
		"helper": {
			"range": "Write {{min}}–{{max}} words to submit your response",
			"min": "Write at least {{min}} words to submit your response",
			"max": "Shorten your response to {{max}} words or fewer"
		}
	},
	"navbar": {
		"home": "Home",
		"progress": "Progress",
		"insights": "Insights",
		"leaderboard": "Leaders",
		"store": "Store",
		"more": "More",
		"redeem": "Redeem",
		"study-pack": "Study-Pack",
		"podcasts": "Podcasts",
		"modules": "Modules",
		"account": "Account settings",
		"accountTab": "Account",
		"privacy": "Privacy",
		"terms": "Terms",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Entered the code perfectly and still having an issue? **Contact support** and make sure to include your access code and purchase details",
		"olxDialog": {
			"unlockedTitle": "Access Unlocked",
			"expiredTitle": "Access Expired",
			"testInfo": "**Exam:** {{examName}} | **Test:** {{bundleName}}",
			"upcomingBody_one": "Your access to the OLX test has been unlocked!\n\nYou can start your session in **{{count}} day**. Please check back later to begin your session from the Practice Tests tab.",
			"upcomingBody_other": "Your access to the OLX test has been unlocked!\n\nYou can start your session in **{{count}} days**. Please check back later to begin your session from the Practice Tests tab.",
			"activeBody": "Your access to the OLX test is now active!\n\nYou can start your session anytime before **{{date}}**.\n\nWould you like to begin your session now or start it later?",
			"expiredBody": "Your access to the OLX test has expired on **{{date}}**.\n\nPlease contact your professor or school administrator for further assistance.",
			"startNowCta": "Start Now",
			"startLaterCta": "Start Later"
		},
		"unexpectedError": "An unexpected error occurred."
	},
	"redeemCode": {
		"titleRedeem": "Redeem Access",
		"titleGranted": "Access Granted",
		"formTitle": "Enter your access code",
		"accessCodeHint": "If you have an access code, please enter it here, including the dashes.",
		"submit": "Redeem",
		"access": "Access here",
		"helpFindCode": "Need help finding your code?",
		"troubleRedeeming": "Having trouble redeeming? Ask Assistant!",
		"skipStep": "Skip this step"
	},
	"autoRedeem": {
		"redeem": "Redeem",
		"redeeming": "Redeeming...",
		"continue": "Continue",
		"unredeemedPrompt_one": "There is **{{count}} product** associated with the email address **{{email}}** that has not been redeemed. Would you like to add it to your account?",
		"unredeemedPrompt_other": "There are **{{count}} products** associated with the email address **{{email}}** that have not been redeemed. Would you like to add them to your account?",
		"successMessage_one": "Congratulations! The **product** below has been unlocked on your account. After pressing continue, the context of your app will be changed to reflect the exam: **{{examName}}**. You can change this at any time from your account settings if you wish to study for a different exam or purchase a different product.",
		"successMessage_other": "Congratulations! The **{{count}} products** below have been unlocked on your account. After pressing continue, the context of your app will be changed to reflect the exam: **{{examName}}**. You can change this at any time from your account settings if you wish to study for a different exam or purchase a different product."
	},
	"olxEligibility": {
		"goToPracticeTests": "Go to Practice tests"
	},
	"moreChallenges": {
		"challenges": "Challenges",
		"challengesCount": "{{value}} Challenges"
	},
	"tts": {
		"tooltip": "Listen"
	},
	"commandBar": {
		"placeholder": "Search...",
		"input": {
			"placeholder": "Type a command or search"
		},
		"sections": {
			"quickActions": "Quick actions"
		},
		"actions": {
			"changeExam": "Change exam",
			"switchToDarkMode": "Switch to dark mode",
			"switchToLightMode": "Switch to light mode",
			"setExamDate": "Set exam date"
		}
	},
	"filterView": {
		"placeholder": "Search exams..."
	},
	"transcript": {
		"show": "Show transcript",
		"hide": "Hide transcript"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "App Logo",
			"testNameLabel": "Test Name",
			"sectionLabel": "Section",
			"back": "Go back",
			"pause": "Pause",
			"menuLabel": "More options"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Test progress",
			"of": "of",
			"pauseSession": "Pause Session",
			"timerTooltip": {
				"item": "Time remaining for this question",
				"section": "Time remaining in this section",
				"test": "Time remaining in this test"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Next"
		},
		"progressBar": {
			"timeLeftLabel": "Time left for this question",
			"timeLeftForUnit": "Time left for this unit",
			"questionOf": "Question {{current}} of {{total}}",
			"questionProgress": "<b>{{current}}</b> of {{total}}",
			"timesUp": "Time's up",
			"statusTooltips": {
				"answered": "Answered",
				"inProgress": "In Progress",
				"skipped": "Skipped",
				"notSeen": "Not Seen"
			}
		},
		"timeRemainingDialog": {
			"title": "You still have time",
			"body": "Time is still remaining on this unit. Would you like to review your answers before submitting?",
			"reviewCta": "Review my answers"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Source",
				"answerTitle": "Your Answer",
				"remainingBadge": "{{count}} remaining",
				"placedBadge": "{{count}} placed",
				"pointsBadge": "{{earned}}/{{max}} points",
				"emptyHint": "Drag paragraphs here from the left panel"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Support Information",
			"emailLabel": "Email",
			"subjectLabel": "Subject",
			"messageBodyLabel": "Message Body",
			"appDetailsLabel": "App Details",
			"appNameLabel": "Name",
			"versionLabel": "Version",
			"platformLabel": "Platform"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} Support Assistant",
			"fallbackTitle": "Chat",
			"betaWarning": "This AI assistant is in **Beta**—responses may occasionally be inaccurate or incomplete.",
			"greeting": "Hey there 👋 Are you having trouble gaining access to a product? I'm here to help! First, let's narrow down the problem. Which of the following best describes your situation?\n\n1. I have an access code, but it doesn't seem to be working.\n2. I made a purchase, but cannot seem to find my access code.\n3. I should have been granted access via my school, but cannot find my access code.\n4. I previously had access to a product, but it's currently inaccessible to me.\n\nPlease enter the number corresponding to your issue.",
			"input": {
				"label": "Type a message...",
				"sendLabel": "Send"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Redeemed Successfully",
			"previouslyRedeemedTitle": "🚀 Previously Redeemed",
			"subtitle": "Access your content here",
			"expires": "Expires: {{date}}",
			"openCta": "Open"
		},
		"purchases": {
			"title": "🎉 Found Access Codes",
			"subtitle": "Redeem to get access to your content",
			"accessCodesLabel_one": "Access Code",
			"accessCodesLabel_other": "Access Codes",
			"moreCodes_one": "(+ {{count}} more)",
			"moreCodes_other": "(+ {{count}} more)",
			"featuresLabel": "Features",
			"redeemCta": "Redeem"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "New version available, please click refresh to update.",
			"refreshCta": "Refresh",
			"refreshA11yLabel": "Refresh to update app",
			"dismissTooltip": "Dismiss",
			"dismissA11yLabel": "Dismiss update notification"
		}
	},
	"cme": {
		"type": "CME type",
		"chooseExportMethod": "Choose export method",
		"selectDateRange": "Select date range",
		"from": "From",
		"to": "To",
		"sendPdfTo": "Send pdf to {{email}}",
		"downloadCertificate": "Download Certificate to PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "CME Credit Earned",
		"confirmYourName": "Confirm your name",
		"certificateNameNotice": "This name will be printed on your CME Certificate.",
		"firstName": "First name",
		"lastName": "Last name",
		"firstNamePlaceholder": "Enter your first name",
		"lastNamePlaceholder": "Enter your last name",
		"confirm": "Confirm",
		"creditsEarnedTitle": "CME Earned",
		"creditRatioCaption": "12 Challenges = 1 CME Credit",
		"earned": "Earned",
		"available": "Available",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Export CME Certificate",
		"exportDisabledCaption": "You need to earn at least 1 CME credit to export your certificate",
		"viewDisclaimer": "View CME disclaimer"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "Description",
			"tagsHeading": "Tags",
			"citationsHeading": "Citations",
			"playing": "Playing"
		},
		"a11y": {
			"artwork": "{{title}} artwork",
			"playEpisode": "Play episode, {{duration}}",
			"pauseEpisode": "Pause episode",
			"play": "Play",
			"pause": "Pause",
			"addToQueue": "Add to queue",
			"removeFromQueue": "Remove from queue",
			"addBookmark": "Bookmark",
			"removeBookmark": "Remove bookmark",
			"seekBar": "Seek bar",
			"skipPrevious": "Skip to previous track",
			"skipNext": "Skip to next track",
			"rewind": "Rewind {{seconds}} seconds",
			"fastForward": "Fast forward {{seconds}} seconds",
			"playbackSpeed": "Playback speed {{speed}}x"
		}
	}
}
